/**
 * next/image özel loader — CDN DIT URL'lerini ("{origin}/{W}x{H}/{Q}/{fit}/{path}")
 * istenen genişliğe göre yeniden yazar; en-boy oranı kaynak URL'den korunur.
 * DIT olmayan URL'ler (ytimg, s3, /storage vb.) olduğu gibi geçer.
 */
const DIT_RE = /^(https?:\/\/[^/]+)\/(\d+)x(\d+)\/(\d+)\/(cover|inside)\/(.+)$/i

/** lib/image-presets DELIVERY_QUALITY_CAP ile aynı — loader bağımsız dosya olmalı */
const QUALITY_CAP = 70

export default function cdnImageLoader({
  src,
  width,
  quality,
}: {
  src: string
  width: number
  quality?: number
}): string {
  const m = String(src || '').match(DIT_RE)
  if (!m) return src
  const [, origin, w0, h0, q0, fit, rest] = m
  const sourceW = Number(w0)
  const sourceH = Number(h0)
  if (!sourceW || !sourceH) return src
  const height = Math.max(1, Math.round((width * sourceH) / sourceW))
  // URL'deki preset kalitesi korunur (örn. sideCard q60); next/image'in
  // default 75'i onu yukarı çekmesin — en düşük olan kazanır, tavan 70.
  const q = Math.min(quality || QUALITY_CAP, Number(q0) || QUALITY_CAP, QUALITY_CAP)
  return `${origin}/${width}x${height}/${q}/${fit}/${rest}`
}
